import { useEffect, useState } from 'react'
import { Modal } from '../../../components/Modal'
import {
    formatTeam,
    getLosingAmount,
    getWinningAmount,
} from '../../bets/helpers'
import { BetIF } from '../../bets/types'
import styles from './PendingReportModal.module.css'
import { getBetErrorScreenshot, modifyBet } from '../../../services/api'

interface PropsIF {
    bet: BetIF | undefined
    setBetModal: React.Dispatch<
        React.SetStateAction<{
            isOpen: boolean
            bet: BetIF | undefined
        }>
    >
    setCachedBets: React.Dispatch<React.SetStateAction<BetIF[]>>
    cachedBets: BetIF[]
}

export const PendingReportModal = (props: PropsIF) => {
    const { bet, setBetModal, setCachedBets, cachedBets } = props
    const [outcome, setOutcome] = useState<string>(bet?.outcome ?? 'Won')
    const [amount, setAmount] = useState<string>(
        bet ? getWinningAmount(bet).toFixed(2) : '0'
    )
    const [status, setStatus] = useState<string>(bet?.status ?? 'COMPLETED')
    const [transactionCode, setTransactionCode] = useState<string>(
        bet?.transactionCode ?? ''
    )
    const [risk, setRisk] = useState<string>(bet?.riskAmount?.toFixed(2) ?? '')

    useEffect(() => {
        if (!bet) return
        if (outcome === 'Void' || outcome === 'Push') {
            setAmount('0')
        } else if (outcome === 'Won') {
            setAmount(getWinningAmount(bet).toString())
        } else {
            setAmount(getLosingAmount(bet).toString())
        }
    }, [outcome, bet])

    const submit = async () => {
        if (!bet) return
        await modifyBet({
            betId: bet.id,
            outcome: outcome,
            outcomeAmount: amount,
            status: status,
            transactionCode: transactionCode,
            risk: risk,
        })
        setBetModal({ isOpen: false, bet: bet })
        let newBets = cachedBets
        const indexToReplace = newBets.findIndex((b) => b === bet)
        newBets[indexToReplace] = {
            ...bet,
            outcome: outcome,
            outcomeAmount: Number(amount),
            status: status,
            transactionCode: transactionCode,
            riskAmount: Number(risk),
        }
        setCachedBets(newBets)
    }

    const downloadErrorScreenshot = async (betId: number) => {
        const response = await getBetErrorScreenshot(betId)
        if (!response) return
        window.open(response)
    }

    return (
        <Modal onClose={() => setBetModal({ bet: bet, isOpen: false })}>
            <form onSubmit={(e) => e.preventDefault()}>
                {bet && (
                    <div className={styles.modal}>
                        <div className={styles.header}>
                            <p>
                                {`${bet.provider.name} | ${bet.account.website
                                    } | ${bet.account.username} | ${formatTeam(
                                        bet.odds.game.awayTeam,
                                        bet.odds.game.homeTeam
                                    )} ${bet.odds.category} | ${bet.odds.group}${bet.odds.description
                                        ? ` | ${bet.odds.description}`
                                        : ''
                                    }
              ${bet.realOddsLine
                                        ? ` | ${bet.realOddsLine > 0 ? '+' : ''}${bet.realOddsLine
                                        }`
                                        : ''
                                    }`}
                            </p>
                        </div>
                        <div className={styles.details}>
                            <div className={styles.details_row}>
                                <label>Status</label>
                                <select
                                    onChange={(e) => setStatus(e.target.value)}
                                    value={status}
                                >
                                    <option value="COMPLETED">COMPLETED</option>
                                    <option value="ERROR">ERROR</option>
                                </select>
                            </div>
                            <div className={styles.details_row}>
                                <label>Outcome</label>
                                <select
                                    onChange={(e) => setOutcome(e.target.value)}
                                    value={outcome}
                                >
                                    <option value="Won">Won</option>
                                    <option value="Lost">Lost</option>
                                    <option value="Void">Void</option>
                                    <option value="Push">Push</option>
                                    <option value="Error">Error</option>
                                </select>
                            </div>
                            <div className={styles.details_row}>
                                <label>Risk Amount</label>
                                <input
                                    style={{ width: '100%' }}
                                    value={risk}
                                    onChange={(e) => setRisk(e.target.value)}
                                />
                            </div>
                            <div className={styles.details_row}>
                                <label>Outcome Amount</label>
                                <input
                                    style={{ width: '100%' }}
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                            </div>
                            <div className={styles.details_row}>
                                <label>Transaction Code</label>
                                <input
                                    style={{ width: '100%' }}
                                    value={transactionCode}
                                    onChange={(e) =>
                                        setTransactionCode(e.target.value)
                                    }
                                />
                            </div>
                            <div className={styles.details_row}>
                                <button
                                    type="submit"
                                    style={{ width: '100%' }}
                                    onClick={() => submit()}
                                >
                                    Submit
                                </button>
                            </div>
                            {bet.errorCode && (
                                <div className={styles.details_row}>
                                    <button
                                        style={{ width: '100%' }}
                                        onClick={() =>
                                            downloadErrorScreenshot(bet.id)
                                        }
                                    >
                                        Download Error Screenshot
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </form>
        </Modal>
    )
}
